import { CallbackForm, CallbackModal } from '@cian/callback-widget';
import '@cian/callback-widget/dist/callback-widget.css';
import * as React from 'react';
import { PhoneIcon } from '../../ui/icon/icons/phone';
import { PikButton } from '../../ui/pik_button/pik_button';
import { getRegionPhone, Region } from '../../utils/regions';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../types/redux';
import { IRequestCallbackInterface, IRequestCallbackResultInterface } from '@cian/callback-widget/lib/shared/utils/api';
import { sendCallbackInfo } from '../../actions/callback';
const styles = require('./recall_button.css');

interface IState {
  callbackModalIsOpened: boolean;
}

interface IInjectedProps {
  sendCallbackInfo(query: IRequestCallbackInterface): Promise<IRequestCallbackResultInterface>;
}
interface IStoreProps {
  region: Region;
}

type IProps = IInjectedProps & IStoreProps;

class RecallButtonComponent extends React.PureComponent<IProps, IState> {
  public state: IState = {
    callbackModalIsOpened: false,
  };

  private modalRoot: HTMLBodyElement;

  public componentDidMount() {
    this.modalRoot = document.getElementsByTagName('body')[0];
  }

  private sendCallbackInfo = (options: IRequestCallbackInterface) => {
    return this.props.sendCallbackInfo(options);
  };

  public render() {
    const phone = getRegionPhone(this.props.region);

    return (
      <div>
        <PikButton buttonStyle={styles['button']} onClick={this.openPopup}>
          <PhoneIcon iconClassName={styles['icon']} />
          Обратный звонок
        </PikButton>
        {this.state.callbackModalIsOpened && (
          <CallbackModal root={this.modalRoot}>
            <CallbackForm
              theme="pik"
              sendAnalytics={true}
              agentPhone={phone}
              close={this.closePopup}
              requestCallback={this.sendCallbackInfo}
            />
          </CallbackModal>
        )}
      </div>
    );
  }

  private openPopup = () => {
    this.setState({ callbackModalIsOpened: true });
  };

  private closePopup = () => {
    this.setState({ callbackModalIsOpened: false }, () => {
      document.body.style.overflow = 'auto';
    });
  };
}

export const RecallButton = connect(
  (state: IApplicationState) => ({
    region: state.filter.query.region,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      sendCallbackInfo: (query: IRequestCallbackInterface) => {
        return dispatch(sendCallbackInfo(query));
      },
    };
  },
)(RecallButtonComponent);
